var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('hero',{attrs:{"heading":_vm.entry.title,"images":_vm.entry.heroImages,"position":"bottom"}}),_vm._v(" "),(_vm.entry.body)?_c('div',{staticClass:"c-section"},[_c('div',{staticClass:"o-wrapper o-wrapper--small"},[_c('div',{staticClass:"c-rte o-box-off",domProps:{"innerHTML":_vm._s(_vm.entry.body)}})])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1654fc0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Privacy.vue
// module id = null
// module chunks = 